import React, { Component } from "react";
import DownloadFormCard from "./downloadFormCard";
import ConfigGeneratorCard from "./configGeneratorCard";
import "./sideCards.css";

/**
 * Hero altındaki iki ana CTA butonu — her ikisi de
 * canlı verilerle çalışır, JSON fetch artık gerekmiyor.
 */
export default class SideCards extends Component {
  render() {
    return (
      <>
        <DownloadFormCard />
        <ConfigGeneratorCard />
      </>
    );
  }
}
